import { Box, Button, Typography } from '@mui/material'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import React from 'react'

interface BinRow {
  id: string
  bin: string
  company: string
  preferred: string
  onHand: number
  available: number
}

interface BinListDisplayProps {
  bins: BinRow[]
  selectedLocation: string
  itemCode: string
  itemName: string
  itemUpcCode: string
  onBack: () => void
  onEditBin: (bin: string) => void
  loading: boolean
}

const BinListDisplay: React.FC<BinListDisplayProps> = ({
  bins,
  selectedLocation,
  itemName,
  itemUpcCode,
  onBack,
  onEditBin,
  loading
}) => {
  const columns: GridColDef[] = [
    { field: 'bin', headerName: 'Bin', flex: 0.7 },
    { field: 'onHand', headerName: 'On Hand', flex: 0.7 },
    { field: 'available', headerName: 'Ava', flex: 0.7 },
    { field: 'preferred', headerName: 'Pre', flex: 0.7 }
  ]

  return (
    <Box>
      <Box sx={{ margin: '20px' }}>
        <Button variant='outlined' onClick={onBack} disabled={loading}>
          Back
        </Button>
      </Box>
      <Box sx={{ textAlign: 'center', marginBottom: '20px' }}>
        <Typography>Location: {selectedLocation}</Typography>
        <Typography>Item Name: {itemName}</Typography>
        <Typography>Item UPC: {itemUpcCode}</Typography>
      </Box>
      <DataGrid
        sx={{
          width: '90%',
          margin: '0 auto',
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 'bold'
          },
          '& .MuiDataGrid-row': {
            cursor: 'pointer'
          }
        }}
        rows={bins}
        columns={columns}
        loading={loading}
        onRowClick={params => onEditBin(params.row.bin)}
      />
    </Box>
  )
}

export default BinListDisplay
